import { safeSessionStorage } from '@toss/storage';

import { type IssuedQuizQuote, parseIssuedQuizQuote } from './quizQuoteApi';

const STORAGE_KEY_PREFIX = 'quizQuoteResult';

class QuoteResultStorage {
  private createKey(): string {
    return `${STORAGE_KEY_PREFIX}_${Date.now()}`;
  }

  save(quote: IssuedQuizQuote): string {
    const key = this.createKey();
    safeSessionStorage.set(key, JSON.stringify(quote));
    return key;
  }

  saveAndVerify(quote: IssuedQuizQuote): string {
    const key = this.save(quote);

    if (!this.get(key)) {
      throw new Error('견적서 결과를 브라우저 세션에 저장할 수 없습니다.');
    }

    return key;
  }

  get(key: string): IssuedQuizQuote | null {
    if (!this.isValidKey(key)) return null;

    const raw = safeSessionStorage.get(key);
    if (!raw) return null;

    try {
      return parseIssuedQuizQuote(JSON.parse(raw));
    } catch (_error) {
      return null;
    }
  }

  isValidKey(key: unknown): key is string {
    return typeof key === 'string' && key.startsWith(`${STORAGE_KEY_PREFIX}_`);
  }

  getKeyFromQuery(queryValue: string | string[] | undefined): string | null {
    const key = Array.isArray(queryValue) ? queryValue[0] : queryValue;
    return this.isValidKey(key) ? key : null;
  }
}

export const quoteResultStorage = new QuoteResultStorage();
